import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { FavoriteStop } from '../journey-planner.model';
import * as JourneyPlannerSelectors from './journey-planner.selectors';
import * as actions from './journey-planner.actions';

@Injectable()
export class JourneyPlannerFacade {
    favoriteStops$ = this.store.pipe(select(JourneyPlannerSelectors.favoriteStops));

    constructor(private store: Store) {}

    getFavoriteStops(): void {
        this.store.dispatch(actions.getFavoriteStops());
    }
    addFavoriteStop(favoriteStop: FavoriteStop): void {
        this.store.dispatch(actions.addFavoriteStop({ favoriteStop }));
    }
    deleteFavoriteStops(favoriteStops: FavoriteStop[]): void {
        this.store.dispatch(actions.deleteFavoriteStops({ favoriteStops }));
    }
    deleteFavoriteStop(favoriteStop: FavoriteStop): void {
        this.store.dispatch(actions.deleteFavoriteStop({ favoriteStop }));
    }

    refreshFavoriteStops(): void {
        this.store.dispatch(actions.refreshFavoriteStops());
    }
}
